/** Вкладка «все» в списках упаковок — значение не из справочника, поэтому строка. */
export const TAB_ALL = 'הכול'

/** Односимвольные коды типа упаковки: приходят в PD_Type и в Pack_Pallet. */
export const PACK_TYPE_LABELS: Record<string, string> = {
  א: 'אריזות',
  מ: 'משטחים',
}
